<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
    <template v-slot:main>
      <head-utils title="Pesquisar Produtos"/>
      <breadcrumb :items="[{label: 'Pesquisa de Produtos', path: 'products'}]"/>

      <form @submit.prevent.stop="submit">
        <ibox>
          <template v-slot:title v-if="!$appUtils.isMobile()">
            <h5>Filtros de Pesquisa</h5>
          </template>

          <template v-slot:content>
            <div v-if="!$appUtils.isMobile() || filterMode" class="container-fluid-grid">
              <div class="form-row" v-if="!$appUtils.isMobile() || filterMode">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="productSearchName">Nome</label>
                    <input id="productSearchName" type="text" class="form-control form-control-sm"
                           v-model="search_params.name"/>
                  </div>
                </div>
              </div>

              <div v-if="$appUtils.isMobile() && !filterMode">
                <div class="list-card" v-for="p in search.entries">
                  <span class="header">{{ p.name }}</span>
                  <span class="cat">{{ p.product_category.name }}</span>
                  <span class="perc">Comissão: {{ p.percentage_commission }}%</span>
                  <span class="trib">{{ p.tributacao }}</span>
                  <span class="pack">{{ p.package_type === 'package' ? 'Saca' : 'Peso' }}<span
                      v-if="p.package_type === 'package'"> | Qtd: {{ p.quantity_package }}</span></span>
                  <span class="updated">Modificado: {{ p.updated_at | formatDate('DD/MM/YYYY HH:mm') }}</span>

                  <div class="act">
                    <router-link :to="{path: `/products/${p.id}/edit`}" class="btn btn-dark btn-sm m-r">
                      <svg-icon icon="pencil-alt"/>
                    </router-link>
                    <button type="button" class="btn btn-danger btn-sm" @click="confirmDestroy(p.id)">
                      <svg-icon icon="trash-alt"/>
                    </button>
                  </div>
                </div>
              </div>

              <div v-if="$appUtils.isMobile()">
                <fab type="button" v-if="!filterMode && !isOpenFabMenu" icon="bars" color="green"
                     @click="isOpenFabMenu = true"/>
                <fab type="button" v-if="isOpenFabMenu && !filterMode" icon="times" color="dark"
                     @click="isOpenFabMenu = false"/>

                <fab type="button" icon="filter" size="mini" v-if="isOpenFabMenu && !filterMode"
                     :custom-style="{bottom: '100px'}" color="red" @click="filterMode = true"/>
                <fab type="link" to="/products/new" icon="plus" size="mini" v-if="isOpenFabMenu && !filterMode"
                     :custom-style="{bottom: '160px'}" color="blue" @click="filterMode = true"/>


                <div ref='end_grid' class="t-c">
                  <svg-icon v-if="searching" icon="sync" class="refresh load-more-crud"/>
                </div>
              </div>
            </div>
          </template>

          <template v-slot:footer>
            <div class="row" v-if="filterMode || !$appUtils.isMobile()">
              <div class="col-sm-12 t-r">
                            <span class="btn-group btn-group-sm" role="group" aria-label="Comandos de Pesquisa">
                                    <button type="button" @click="reset" class="btn btn-secondary btn-sm"><svg-icon
                                        icon="sync"/> Limpar</button>
                                    <router-link to="/products/new" class="btn btn-dark btn-sm"><svg-icon icon="plus"/> Criar Novo</router-link>
                                    <button type="submit" class="btn btn-theme-1 btn-sm"><svg-icon icon="search"/> Pesquisar</button>
                                </span>
              </div>
            </div>
            <div class="row" v-if="$appUtils.isDesktop()">
              <div class="col-sm-12">
                <br/>
                <Pagination
                    :page_size="search.per_page"
                    :current_page="search.current_page"
                    :total_entries="search.total_entries"/>

                <Loading :visible="searching"/>
                <table class="table table-hover table-striped table-sm table-bordered">
                  <thead class="thead-dark thead-center">
                  <tr>
                    <th>NOME</th>
                    <th>CATEGORIA</th>
                    <th>PERC. COMISSÃO</th>
                    <th>TRIBUTADO / DIFERIDO</th>
                    <th>PESO / SACA</th>
                    <th>QTD SACA</th>
                    <th>MODIFICADO EM</th>
                    <th class="column-1"></th>
                  </tr>
                  </thead>
                  <tbody v-if="search && search.entries">
                  <tr v-for="p in search.entries">
                    <td class="v-m c-p" @click="edit(p.id)">{{ p.name }}</td>
                    <td class="v-m c-p" @click="edit(p.id)">{{ p.product_category.name }}</td>
                    <td class="v-m c-p t-r" @click="edit(p.id)">{{ p.percentage_commission }}</td>
                    <td class="v-m c-p t-c" @click="edit(p.id)" style="text-transform: capitalize">
                      {{ p.tributacao }}
                    </td>
                    <td class="v-m c-p t-c" @click="edit(p.id)">{{ p.package_type === 'package' ? 'Saca' : 'Peso' }}
                    </td>
                    <td class="v-m c-p t-r" @click="edit(p.id)">{{ p.quantity_package }}</td>
                    <td class="v-m c-p t-c" @click="edit(p.id)">{{ p.updated_at | formatDate('DD/MM/YYYY HH:mm') }}
                    </td>

                    <td class="t-c v-m">
                      <button type="button" class="btn btn-danger btn-xs"
                              @click="confirmDestroy(p.id)">
                        <svg-icon icon="trash-alt"/>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <Pagination
                    :page_size="search.per_page"
                    :current_page="search.current_page"
                    :total_entries="search.total_entries"/>
              </div>
            </div>
          </template>
        </ibox>

      </form>
    </template>
  </DefaultTmpl>
</template>

<script>
import Pagination from '@/components/Pagination'
import CRUDSearch from '@/mixins/CRUDSearch'
import Fab from "../../components/particles/Fab";
import Loading from "../../components/particles/Loading";
import DefaultTmpl from "@/templates/DefaultTmpl.vue";

export default {
  name: "ProductsSearch",
  components: {
    DefaultTmpl,
    Loading,
    Fab,
    Pagination
  },
  mixins: [
    CRUDSearch.mount('products')
  ],
  data() {
    return {
      isOpenFabMenu: false
    }
  },
  methods: {
    getIntersectItemListener() {
      return this.$refs.end_grid;
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/variables";

.list-card {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;
  grid-template-areas: "header cat"
        "perc trib"
        "pack updated"
        "act act";
  grid-gap: 5px;
  font-size: .8em;

  padding: 5px;

  &:not(:first-child) {
    border-top: 1px solid #e7eaec;
  }

  .header {
    color: $theme_color_one;
    font-weight: 700;
    grid-area: header;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .cat {
    grid-area: cat;
    text-align: right;
    font-weight: bold;
  }

  .perc {
    grid-area: perc;
    text-transform: uppercase;
  }

  .trib {
    grid-area: trib;
    text-align: right;
    text-transform: uppercase;
  }

  .pack {
    grid-area: pack;
    text-transform: uppercase;
  }

  .updated {
    text-align: right;
    grid-area: updated;
  }

  .act {
    grid-area: act;
    text-align: right;

    .m-r {
      margin-right: 5px;
    }
  }
}
</style>
